import Immutable from 'immutable';
import { BreadcrumbItem } from './BreadcrumbItem';

export interface RawBreadcrumbs {
  folders: Immutable.OrderedSet<BreadcrumbItem>;
  key: string;
}

const defaultValues: RawBreadcrumbs = {
  folders: Immutable.OrderedSet<BreadcrumbItem>(),
  key: '',
};

export const BreadcrumbsFactory = Immutable.Record(
  defaultValues,
  'Breadcrumbs'
);

export class Breadcrumbs extends BreadcrumbsFactory {
  static deserialize(RawBreadcrumbs: RawBreadcrumbs): Breadcrumbs {
    return new Breadcrumbs(RawBreadcrumbs);
  }

  serialize(): RawBreadcrumbs {
    return this.toJS();
  }
}
